import React from 'react';
import { outcomes } from '../data/outcomes';
import { OFFER_ANCHOR } from './constants';
export function ChangeSection() {
  return <section className="bg-white px-4 py-5" data-id="element-25" data-mp="zn94f6f1bqu6">
      <div className="mx-auto max-w-4xl" data-id="element-26" data-mp="lwm4xc1g9wx1">
        <h2 className="mb-2 text-center font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-27" data-mp="lvkun9s9degd">
          Ce qui va changer
        </h2>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-28" data-mp="byg46xrdqwtr">
          {outcomes.map(outcome => <a key={outcome.title} href={OFFER_ANCHOR} className="rounded-xl border border-brand-line bg-brand-cream p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-orange" data-id="element-29" data-mp="gx9kexy1x1xm">
              <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-30" data-mp="7x4n5gmknjx6">
                {outcome.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-31" data-mp="22b5kty6dy0vo">
                {outcome.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}